//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InputTags from '@/components/form/InputTags'

export default {
  name: 'CategorySkillSelector',
  components: { InputTags },
  props: {
    selectedCategories: {
      type: Array,
      default () {
        return []
      }
    },
    categoriesValidation: {
      type: Object,
      default: null
    },
    selectedSkills: {
      type: Array,
      default () {
        return []
      }
    },
    skillsValidation: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      form: {
        categories: [],
        skills: []
      }
    }
  },
  computed: {
    /**
     * Get all skills for dropdown
     */
    categories () {
      return this.$store.getters['util/getCategoriesByName']
    },

    /**
     * Get all skills for dropdown by selected categories
     */
    skills () {
      return this.$store.getters['util/getSkillsByCategories'](this.form.categories)
    }
  },
  watch: {
    selectedCategories (n) {
      this.form.categories = n?.map(i => i.id)
    },
    selectedSkills (n) {
      this.form.skills = n?.map(i => i.id)
    }
  },
  methods: {
    updatedCategories (e) {
      this.form.categories = e
      this.emit()
    },
    updatedSkills (e) {
      this.form.skills = e
      this.emit()
    },
    emit () {
      this.$emit('input', {
        categories: this.categories.filter(c => this.form.categories.includes(c.id)),
        skills: this.skills.filter(c => this.form.skills.includes(c.id))
      })
    }
  }
}
